export default __webpack_public_path__ + "elevation-800-0626b73b953321577d7fd71c22547a1c.webp";